import { Component, Input, EventEmitter, Output, QueryList, ViewChildren, OnInit } from '@angular/core';
import { TrackingTrackerFilterComponent } from '../tracking-tracker-filter/tracking-tracker-filter.component';
import { ConsolGridOrderBy } from '../../models/consol-grid-order-by.enum';
import { ConsolListFilterRequest } from '../../models/consol-list-filter-request.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';



@Component({
  selector: 'app-tracking-tracker-filter-panel',
  templateUrl: './tracking-tracker-filter-panel.component.html',
  styleUrls: ['./tracking-tracker-filter-panel.component.scss'],
  imports: [CommonModule, TrackingTrackerFilterComponent, FormsModule],
})

// @Injectable({
//   providedIn: 'root',
// })
export class TrackingTrackerFilterPanelComponent implements OnInit {
  @Input() public filter: ConsolListFilterRequest;
  @Input() public columns: any;

  @Output() public afterClearFilters: EventEmitter<{}> = new EventEmitter();
  @Output() public updateFilters: EventEmitter<{}> = new EventEmitter();

  @ViewChildren(TrackingTrackerFilterComponent) public filters: QueryList<TrackingTrackerFilterComponent>;

  public lastAppliedFilter: ConsolListFilterRequest;

  public ngOnInit(): void {
    if (this.valueInSession()) {
      this.filter.HouseBillNumber = sessionStorage.getItem('HBL');
      this.filter.MasterBillNumber = sessionStorage.getItem('MBL');
      this.filter.ContainerNumber = sessionStorage.getItem('Container');
      this.filter.CustomerRefNumber = sessionStorage.getItem('CustomerRef');
      this.filter.ShipmentCode = sessionStorage.getItem('ShipmentCode');
    }
    this.initLastAppliedFilter();
  }

  public onFilterInputChange(value: string, column: ConsolGridOrderBy): void {
    switch (column) {
      case ConsolGridOrderBy.MasterBillNumber:
        this.filter.MasterBillNumber = value;
        break;
      case ConsolGridOrderBy.HouseBillNumber:
        this.filter.HouseBillNumber = value;
        break;
      case ConsolGridOrderBy.ContainerNumber:
        this.filter.ContainerNumber = value;
        break;
      case ConsolGridOrderBy.CustomerRefNumber:
        this.filter.CustomerRefNumber = value;
        break;
      case ConsolGridOrderBy.ShipmentCode:
        this.filter.ShipmentCode = value;
        break;
    }
  }

  public clearFilters(): void {
    this.filters.forEach(filter => {
      filter.clearFilter();
    });
    sessionStorage.removeItem('MBL');
    sessionStorage.removeItem('HBL');
    sessionStorage.removeItem('Container');
    sessionStorage.removeItem('CustomerRef');
    sessionStorage.removeItem('ShipmentCode');
    this.initLastAppliedFilter();

    this.afterClearFilters.emit();
  }

  public isFilterEmpty(): boolean {
    return !this.filter.ContainerNumber && !this.filter.CustomerRefNumber && !this.filter.HouseBillNumber && !this.filter.MasterBillNumber
           && !this.filter.ShipmentCode;
  }

  public isFilterChanged(): boolean {
    return this.filter.MasterBillNumber !== this.lastAppliedFilter.MasterBillNumber ||
      this.filter.HouseBillNumber !== this.lastAppliedFilter.HouseBillNumber ||
      this.filter.ContainerNumber !== this.lastAppliedFilter.ContainerNumber ||
      this.filter.CustomerRefNumber !== this.lastAppliedFilter.CustomerRefNumber ||
      this.filter.ShipmentCode !== this.lastAppliedFilter.ShipmentCode;
  }

  public update(): void {
    this.initLastAppliedFilter();
    sessionStorage.setItem('MBL', this.lastAppliedFilter.MasterBillNumber);
    sessionStorage.setItem('HBL', this.lastAppliedFilter.HouseBillNumber);
    sessionStorage.setItem('Container', this.lastAppliedFilter.ContainerNumber);
    sessionStorage.setItem('CustomerRef', this.lastAppliedFilter.CustomerRefNumber);
    sessionStorage.setItem('ShipmentCode', this.lastAppliedFilter.ShipmentCode);
    this.updateFilters.emit();
  }

  private valueInSession(): boolean {
    return sessionStorage.getItem('MBL') !== null ||
      sessionStorage.getItem('HBL') !== null ||
      sessionStorage.getItem('Container') !== null ||
      sessionStorage.getItem('CustomerRef') !== null ||
      sessionStorage.getItem('ShipmentCode') !== null;
  }



  private initLastAppliedFilter(): void {
    this.lastAppliedFilter = {
      ...this.filter,
    };
  }
}
